import React from 'react';

// Constants (shared between component and helper function)
const thresholds = [30, 60, 120];
const colors = ['#d73027', '#fc8d59', '#91cf60', '#1a9850'];

// Exported helper function
export function getHeightColor(height) {
  if (height > thresholds[2]) return colors[3];
  if (height > thresholds[1]) return colors[2];
  if (height > thresholds[0]) return colors[1];
  return colors[0];
}

// Default component export
const HeightLegend = () => {
  const ranges = [];

  for (let i = colors.length - 1; i >= 0; i--) {
    let label;

    if (i === 0) {
      label = `≤ ${thresholds[0]}`;
    } else {
      label = `> ${thresholds[i - 1]}`;
    }

    ranges.push({ label, color: colors[i] });
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontFamily: 'sans-serif' }}>
      {ranges.map(({ color, label }, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <div style={{ width: 20, height: 20, backgroundColor: color, marginRight: 8 }}></div>
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
};

export default HeightLegend;
